import '/opt/buildhome/repo/node_modules/@storybook/addon-essentials/dist/controls/manager.mjs';